module.exports = __webpack_public_path__ + "static/media/ProximaNova-Regular.bf9f5d50.otf";